<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        โทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> รายงานข้อมูลส่งเสริมการขาย
          </a>
        </li>
        <li class="active">โทรศัพท์เคลื่อนที่</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <div class="col-sm-12">
                      <el-form
                        size="mini"
                        :label-position="label_position"
                        label-width="100px"
                        :model="formLabelAlign"
                      >
                        <div class="col-sm-6">
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                            <el-input v-model="formLabelAlign.name"></el-input>
                          </el-form-item>
                          <el-form-item label="ผู้ให้บริการ">
                            <el-input v-model="formLabelAlign.region"></el-input>
                          </el-form-item>
                          <el-form-item label="ประเภทบริการ">
                            <el-input v-model="formLabelAlign.type"></el-input>
                          </el-form-item>
                          <el-form-item label="สถานะการให้บริการ">
                            <el-input v-model="formLabelAlign.ss"></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ชนิดของประเภทบริการ">
                            <el-select
                              v-model="sizeForm.region"
                              placeholder="please select your zone"
                            >
                              <el-option label="Zone one" value="shanghai"></el-option>
                              <el-option label="Zone two" value="beijing"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลาในการค้นหา">
                            <el-date-picker
                              v-model="value1"
                              type="datetimerange"
                              range-separator="To"
                              start-placeholder="Start date"
                              end-placeholder="End date"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ช่วงราคา">
                            <el-slider v-model="value" :step="0.0001" range :max="1"></el-slider>
                          </el-form-item>
                        </div>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.box-header -->
              <div class="wrapper_chart">
                <div class="layout_btn_export">
                  <a href class="btn btn-primary">Export</a>
                </div>
              </div>
              <div class="table-responsive">
                <div class="box-body">
                  <div class="box-body">
                    <data-tables
                      :data="data"
                      :page-size="5"
                      :pagination-props="{ background: true, pageSizes: [5, 10, 15] }"
                    >
                      <el-table-column
                        v-for="title in titles"
                        :prop="title.prop"
                        :label="title.label"
                        :key="title.label"
                        sortable="custom"
                      ></el-table-column>
                      <!-- <p slot="append">table slot</p> -->
                    </data-tables>
                  </div>
                </div>
                <!-- /.box-body -->
              </div>
              <!--table-responsive-->
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      value: [0.32, 0.945],
      sizeForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      label_position: "top",
      formLabelAlign: {
        name: "",
        region: "",
        type: ""
      },
      data: [
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        }
      ],
      titles: [
        {
          prop: "flow_no",
          label: "NO."
        },
        {
          prop: "content",
          label: "Content"
        },
        {
          prop: "flow_type",
          label: "Type"
        }
      ],
      loading: false,
      total: 0
    };
  }
};
</script>
